import {
  GET_LIST_NOPHAITHU,
  GET_LIST_NOPHAITHU_SUCCESS,
  GET_LIST_NOPHAITHU_FAILURE,
} from "actions/NoPhaiThu/actionTypes";

const initialState = {
  getListNoPhaiThuLoading: false,
  posts: [],
  objList: {
    List: [],
    TongNo: 0,
    TotalMoney: 0,
    TotalNoGoc: 0,
    TotalNoLai: 0,
    TotalQuantity: 0,
  },
  totalRow: 0,
};

const getListNoPhaiThu = (state, action) => ({
  ...state,
  getListNoPhaiThuLoading: true,
});

const getListNoPhaiThuSuccess = (state, action) => {
  return {
    ...state,
    getListNoPhaiThuLoading: false,
    objList: action.payload,
  };
};

const getListNoPhaiThuFailed = (state, action) => ({
  ...state,
  getListNoPhaiThuLoading: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_NOPHAITHU:
      return getListNoPhaiThu(state, action);
    case GET_LIST_NOPHAITHU_SUCCESS:
      return getListNoPhaiThuSuccess(state, action);
    case GET_LIST_NOPHAITHU_FAILURE:
      return getListNoPhaiThuFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
